import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { ApiEndpointsService } from "./api-endpoints.service";
// import {AuthService} from "../shared/services/auth/auth.service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ConfigService {
  response: any;

  constructor(
    private http: HttpClient,
    private apiEndpointsService: ApiEndpointsService,
    private router: Router
  ) {}

  baseData: any;

  async init(): Promise<void> {
    try {
      await this.getBaseData();
    } catch (error: any) {
      if (error.statusCode == 403) {
        console.log("error" + error);
      }
    }
  }
  async getBaseData() {
    return new Promise((resolve, reject) => {
      this.http
        .get(this.apiEndpointsService.getBaseData())
        .pipe(
          catchError((err: HttpErrorResponse) => {
            return throwError(() => err.error || "Server error");
          })
        )
        .subscribe(
          (data) => {
            let initialData = JSON.parse(JSON.stringify(data));
            this.baseData = initialData.data.companies;
            resolve(true);
          },
          (error) => {
            if (error.statusCode == 403) {
              this.baseData = {
                error: "ACCESS_DENIED",
              };
            }
            resolve(true);
          }
        );
    });
  }
}
